/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue } from 'vue-property-decorator'

/**
 * API実行用の共通メソッド群
 */
export namespace ApiBase {
  /** Acceptedのレスポンスコード */
  const RESPONSE_ACCEPTED = 202

  /**
   * 認証情報付きget
   *
   * @param path APIのパス
   * @param params パラメータ
   *
   * @returns レスポンス
   */
  export async function get(path: string, params?: any): Promise<any> {
    // getの場合はparams: {パラメータ}の形式に変換する必要があるため追加処理
    const sendParams = params ? { params: params } : null
    // API実行
    const res = await Vue.prototype.$httpWithToken.get(path, sendParams)
    return res.data
  }

  /**
   * 認証情報付きget(Acceptedが発生するAPI用)
   *
   * @param path APIのパス
   * @param params パラメータ
   *
   * @returns レスポンス(レスポンスコードがAcceptedの場合はnull)
   */
  export async function getWithAccepted(path: string, params?: any): Promise<any> {
    // getの場合はparams: {パラメータ}の形式に変換する必要があるため追加処理
    const sendParams = params ? { params: params } : null
    // API実行
    const res = await Vue.prototype.$httpWithToken.get(path, sendParams)

    // レスポンスコードがAcceptedの場合はnullを固定で返す
    if (res.status === RESPONSE_ACCEPTED) {
      return null
    }

    return res.data
  }

  /**
   * 認証情報付きpost
   *
   * @param path APIのパス
   * @param params パラメータ
   *
   * @returns レスポンス
   */
  export async function post(path: string, params?: any): Promise<any> {
    const res = await Vue.prototype.$httpWithToken.post(path, params)
    return res.data
  }

  /**
   * 認証情報付きpost
   *   ファイルなどのFormDataをパラメータに持たせる際に使用する
   *
   * @param path APIのパス
   * @param formData フォームデータ(ファイル等)
   * @param params パラメータ
   *
   * @returns レスポンス
   */
  export async function postWithFormData(path: string, formData: FormData, params?: any): Promise<any> {
    // リクエストパラメータを定義
    const requestParam = new FormData()

    // formDataを追加
    formData.forEach((value, key) => {
      requestParam.append(key, value)
    })

    // 通常のパラメータがある場合追加
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        requestParam.append(key, value as string)
      }
    }

    const res = await Vue.prototype.$httpWithToken.post(path, requestParam, {
      headers: {
        'Content-Type': 'multipart/form-data', // コンテンツタイプを指定
      },
    })

    return res.data
  }
}
